import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import tokens from '@/styles/tokens';
import * as icons from '../Icons';
import { props as propsDefiniton } from './icon.shared';



export default /*#__PURE__*/_defineComponent({
  __name: 'NkIcon',
  props: propsDefiniton,
  setup(__props) {

const props = __props


const sizeValue = computed(() => tokens.spacing[props.size])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(icons[_ctx.name]), {
    width: _unref(sizeValue),
    height: _unref(sizeValue),
    fill: "currentColor"
  }, null, 8, ["width", "height"]))
}
}

})